import { useFavorites } from "assets/favorites";
import { useActivity } from "assets/utils";

import { Box, Typography } from "@mui/material";
import * as React from "react";
import { RecentActivityList } from "pages/main/components/RecentActivityCard";
import { ActivityLine } from "pages/main/components/ActivityCard";
import { H2HDialog } from "pages/main/components/ActivityCard";
import { useTranslation } from "react-i18next";


export function HomeActivity({activity}) {
    const { t } = useTranslation();

    return activity !== null && <>
        {activity.activity && (activity.activity.singles.length > 0 || activity.activity.doubles.length > 0) ? <>
            <Typography variant="h6" fontWeight="bold" color="text.primary_bold" component="div" sx={{pt: 2}}>
                {t("homeActivity.upcomingMatches")}
            </Typography>
            <ActivityComponent activity={activity.activity} />
        </> : null}

        {activity.activity_recent && (activity.activity_recent.singles.length > 0 || activity.activity_recent.doubles.length > 0) ? <>
            <Typography variant="h6" fontWeight="bold" color="text.primary_bold" component="div" sx={{pt: 2, pb: 2}}>
                {t("homeActivity.recentMatches")}
            </Typography>
            <RecentActivityComponent activity={activity.activity_recent} />
        </> : null}

    </>
}

function ActivityComponent({activity}) {
    const [dialogData, setDialogData] = React.useState(null);

    return <Box sx={{display: "flex", flexDirection: "column", mt: 2, mb: 2, gap: 1}}>
        {activity && activity.singles && activity.singles.map((item, index) => 
            <ActivityLine key={`${item.sid}-${index}`} data={item} doubles={false} setDialogData={setDialogData} firstPlayerClickable={true} />
        )}
        {activity && activity.doubles && activity.doubles.map((item, index) => 
            <ActivityLine key={`${item.sid}-${index}`} data={item} doubles={true} setDialogData={setDialogData} firstPlayerClickable={true} />
        )}

        <H2HDialog open={dialogData !== null} onClose={() => setDialogData(null)} dialogData={dialogData} />
            
    </Box>
}

function RecentActivityComponent({activity}) {
    const combinedActivity = React.useMemo(() => activity && activity.singles && activity.doubles && [...activity.singles, ...activity.doubles].sort((a,b) => new Date(b.date) - new Date(a.date)), [activity]);

    return <RecentActivityList activity={combinedActivity} firstPlayerClickable={true} />
}